var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.isLoggedIn
      ? _c(
          "div",
          {
            staticClass: "header-nav-wrap sp logout",
            staticStyle: { opacity: "0", padding: "0 5%" },
            style: _vm.initialized ? "opacity:1;" : ""
          },
          [_vm._m(0)]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isLoggedIn
      ? _c(
          "div",
          {
            staticClass: "header-nav-wrap sp login",
            staticStyle: { opacity: "0", padding: "0 5%" },
            style: _vm.initialized ? "opacity:1;" : ""
          },
          [
            _c("div", { staticClass: "header-account-wrap" }, [
              _c("p", { staticClass: "header-account-name" }, [
                _c("span", { staticClass: "header-account-name" }, [
                  _vm._v(_vm._s(this.user ? this.user.name : "ゲスト"))
                ]),
                _vm._v("様")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "header-account-logout" }, [
                _vm._v("("),
                _c(
                  "a",
                  {
                    staticClass: "logout-link",
                    attrs: { href: _vm.pagePath.accounts.login },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.$A.$auth.signOut()
                      }
                    }
                  },
                  [_vm._v("ログアウト")]
                ),
                _vm._v(")")
              ])
            ]),
            _vm._v(" "),
            _vm._m(1)
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "header-account-login" }, [
      _c("a", { staticClass: "login-link", attrs: { href: "/login/" } }, [
        _c("i", { staticClass: "far fa-user" }),
        _vm._v("ログイン / 会員登録")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-mypage-wrap" }, [
      _c("p", { staticClass: "mypage" }, [
        _c("a", { staticClass: "mypage-link", attrs: { href: "/mypage/" } }, [
          _c("i", { staticClass: "far fa-user" }),
          _vm._v("マイページ")
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "order" }, [
        _c(
          "a",
          {
            staticClass: "order-link",
            attrs: { href: "/mypage/order-histories/" }
          },
          [_vm._v("注文履歴")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }